import * as angular from "angular";
import {IController} from 'angular';
import * as _ from "lodash";
import {SplitService} from "../../services/split-service.service";
import {PackageConfigurationService} from "../../../site-preferences/services/package-configuration-service.service";
import {DefaultPackageConfigurationFieldsType} from "../../../site-preferences/types/default-package-configuration-fields.type";
import {FieldType} from "../../../site-preferences/types/field.type";

export class bringozPackageItemsListCtrl implements IController {

  items: any;
  isShowAttachments: boolean;
  showExtraInfo: boolean;
  showDescription: boolean;

  public readonly defaultPackageConfigurationFieldsTypesMap: typeof DefaultPackageConfigurationFieldsType = DefaultPackageConfigurationFieldsType;

  public packageConfigurationByType: any;
  private currencySymbol: any;
  private labelsMap: any;

  public readonly fieldTypesMap: typeof FieldType = FieldType;

  /* @ngInject */
  constructor(private splitService: SplitService, private packageConfigurationService: PackageConfigurationService) {
  }

  $onInit() {
    this.packageConfigurationByType = this.packageConfigurationService.getPackageConfigurationsBySize();

    this.currencySymbol = this.splitService.getCurrencySymbol();
    this.labelsMap = {};

    const siteLabels = this.splitService.getSiteLabels();
    _.forEach(siteLabels, (l) => {
      this.labelsMap[l.name] = l;
    })
  };

  $onChanges(changes) {

  };


}

angular
  .module('bringoz.admin.commons')
  .component('bringozPackageItemsList', {
    bindings: {
      items: '<',
      isShowAttachments: '<?',
      showExtraInfo: '<?',
      showDescription: '<?'

    },
    template: require('./bringoz-package-items-list.html').default,
    controller: bringozPackageItemsListCtrl
  });
